
import React from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import { styled } from '@mui/material';

const ColorButton = styled(Button)<ButtonProps>(() => ({
  color: "white",
  backgroundColor: "#d32f2f",
  '&:hover': {
    backgroundColor: "#c62828",
  },
}));

const DeleteButton = (props: any) => (
  <ColorButton {...props} >
    {props.children}
  </ColorButton>
)

export default DeleteButton;
